import { useVoiceCopy } from '@/platform/voice/use-voice';

export function ProfileNoAccess() {
  const copy = useVoiceCopy();
  return (
    <section className="mx-auto max-w-md space-y-3 text-center">
      <h1 className="text-2xl font-bold">Kein Zugriff</h1>
      <p className="text-muted-foreground">{copy('platform.access.profile.denied')}</p>
    </section>
  );
}
